import { useState } from 'react'
import { BookmarkList } from '../components/BookmarkList'
import { CategoryManager } from '../components/CategoryManager'
import { Button } from '../components/Button'

export default function Bookmarks() {
  const [activeTab, setActiveTab] = useState<'bookmarks' | 'categories'>('bookmarks')

  return (
    <div className="space-y-6">
      <div className="flex space-x-4 border-b">
        <Button
          variant={activeTab === 'bookmarks' ? 'primary' : 'outline'}
          onClick={() => setActiveTab('bookmarks')}
        >
          书签管理
        </Button>
        <Button
          variant={activeTab === 'categories' ? 'primary' : 'outline'}
          onClick={() => setActiveTab('categories')}
        >
          分类管理
        </Button>
      </div>

      {activeTab === 'bookmarks' ? <BookmarkList /> : <CategoryManager />}
    </div>
  )
} 